export const ROUTE_PATH = '/parking-whitelist-p3/add';

export const FEATURE_NAME = 'parkingLevelThreeWhitelistAddPage';
